import logo from "../../img/bento/bento-logo.webp";
import bentoNav from "../../img/bento/bento-nav.webp";
import bentoLand from "../../img/bento/bento-land.webp";
import bentoOO from "../../img/bento/bento-oo.webp";
import bentoCampaign from "../../img/bento/bento-campaign.webp";
import bentoPOS from "../../img/bento/bento-pos.webp";
import bentoOne from "../../img/bento/bento-1.webp";
import bentoTwo from "../../img/bento/bento-2.webp";
import bentoThree from "../../img/bento/bento-3.webp";
import bentoFour from "../../img/bento/bento-4.webp";
import BentoCheckIcon from "../icons/BentoCheckIcon";
import "./BentoContent.scss";

export default function BentoContent() {
  return <div className={"bento-content"}>
    <section className={"one"}>
      <p><b>MustHaveMenus recommends <span className="bentobox-desktop">BentoBox.</span></b></p>
      <h1>Get a website built for restaurant success</h1>
      <div className={"flex img-right"}>
        <div className={"half"}>
          <img className={"hero"} src={bentoNav} alt={"Welcome to Bento!"} />
        </div>
        <div className={"half"}>
          <img className={"logo"} src={logo} alt={"logo"} />
          <h2>Discover how BentoBox websites deliver all the tools you need to grow.</h2>
          <p>
            Through eye-catching websites, online ordering, merchandise storefronts, loyalty programs, email marketing, reservations, SEO and more, BentoBox websites help restaurants around the world create the best hospitality experiences possible.
          </p>
          <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>Get a website</a>
        </div>
      </div>
    </section>
    <section className={"two odd"}>
      <div className={"flex"}>
        <div>
          <img src={bentoOne} alt={"Stand Out"} />
          <h3>Websites</h3>
          <p>
            Make an impact with a beautifully branded website.<br/>(BentoBox will build it for you!)
          </p>
        </div>
        <div>
          <img src={bentoFour} alt={"Sell"} />
          <h3>Online Ordering</h3>
          <p>
            Bring in more money with customized, commission-free online ordering.
          </p>
        </div>
        <div>
          <img src={bentoThree} alt={"Engage"} />
          <h3>Email Marketing</h3>
          <p>
            Take advantage of automated email marketing to keep your customers coming back.
          </p>
        </div>
        <div>
          <img src={bentoTwo} alt={"Operate"} />
          <h3>Reservations</h3>
          <p>
            Streamline guest management with our built-in reservations or waitlist functionalities.
          </p>
        </div>
      </div>

      <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>I want a demo!</a>
    </section>

    <section className={"three"}>
      <div className={"flex"}>
        <div className={"half"}>
          <img src={bentoLand} alt={"stand out"} className={"hero"} />
        </div>
        <div className={"half"}>
          <h3 className="pre-header"><b>Stand Out</b></h3>
          <h1>Websites</h1>
          <p>
            BentoBox's expert design team helps restaurants come to life online by building customized websites which, thanks to built-in SEO, rank higher in search results. With a BentoBox website, enjoy:
          </p>

          <div>
            <ul>
              <li><BentoCheckIcon/><span><b>Speedy setup.</b> From kick-off to launch, the entire building process takes less than 30 days.</span></li>
              <li><BentoCheckIcon/><span><b>Eye-catching alerts.</b> Encourage diners to take action through pop-up and banner ads on your homepage.</span></li>
              <li><BentoCheckIcon/><span><b>Design for every device.</b> All layouts are responsive to mobile, tablet, and desktop devices.</span></li>
              <li><BentoCheckIcon/><span><b>Real-time analytics.</b> See how visitors are finding &mdash; and interacting with &mdash; your site.</span></li>
            </ul>
            <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>I want a demo!</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"four odd"}>
      <div className={"flex img-right"}>
        <div className={"half"}>
          <img src={bentoOO} alt={"Sell"} className={"hero"} />
        </div>
        <div className={"half"}>
          <h3 className="pre-header"><b>Sell</b></h3>
          <h1>Online Ordering & More</h1>
          <p>
          Create new streams of revenue by doing sales directly through your website, without the third-party fees. Earn more with:
          </p>
          <div>
            <ul>
              <li><BentoCheckIcon/><span><b>Commission-free online ordering.</b> Give diners a single, branded spot (with a quick and easy checkout experience) where they can place orders with you directly.</span></li>
              <li><BentoCheckIcon/><span><b>Merchandise stores.</b> Bring in revenue 24/7 with a digital storefront where guests can buy gift cards, merchandise, and more anytime.</span></li>
              <li><BentoCheckIcon/><span><b>Ticketed events.</b> From charcuterie board workshops to virtual wine tastings, throw events on your terms &mdash; and manage every detail with ease.</span></li>
              <li><BentoCheckIcon/><span><b>Pre-Order and catering.</b> Take large group orders far in advance.</span></li>
            </ul>
            <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>I want a demo!</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"five"}>
      <div className={"flex"}>
        <div className={"half"}>
          <img src={bentoCampaign} alt={"Engage"} className={"hero"} />
        </div>
        <div className={"half"}>
          <h3 className="pre-header"><b>Engage</b></h3>
          <h1>Marketing & Promotions</h1>
          <p>
            BentoBox provides direct access to diner data. Make the most of it with automated email marketing, loyalty programs, and SMS messaging built to turn first-time guests into regulars.
          </p>
          <div>
            <ul>
              <li><BentoCheckIcon/><span><b>Email marketing.</b> With BentoBox, you can schedule automated email campaigns with incentives to encourage repeat visits.</span></li>
              <li><BentoCheckIcon/><span><b>Loyalty programs.</b> Recognize and reward your most loyal online customers &mdash; and inspire repeat orders &mdash; with an automated loyalty program built into the checkout process.</span></li>
              <li><BentoCheckIcon/><span><b>SMS alerts.</b> Let diners know about promotions and re-engage with lapsed customers through automated SMS messaging, a feature that can be enabled as part of any automated marketing campaign.</span></li>
            </ul>
            <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>I want a demo!</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"six odd"}>
      <div className={"flex img-right"}>
        <div className={"half"}>
          <img src={bentoPOS} alt={"Operate"} className={"hero"} />
        </div>
        <div className={"half"}>
          <h3 className="pre-header">Operate</h3>
          <h1>Reservations & Waitlist</h1>
          <p>
            Streamline operations across front- and back-of-house (and connect the restaurant tech you're already using) for a smoother experience for your team, your diners and your business as a whole.
          </p>
          <div>
            <ul>
              <li><BentoCheckIcon/><span><b>Maximize bookings.</b> Give guests multiple ways to book &mdash; through your website, through Reserve with Google or by phone.</span></li>
              <li><BentoCheckIcon/><span><b>Keep tables moving.</b> Create and assign table inventory with a fully customizable floor plan and see what's happening in your restaurant at a glance.</span></li>
              <li><BentoCheckIcon/><span><b>No reservations? Use a waitlist.</b> Track demand, quote accurate wait times and view your capacity in real-time with a digital waitlist and synced table management system.</span></li>
            </ul>
            <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>I want a demo!</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"seven"}>
      <img className={"logo"} src={logo} alt={"logo"} />
      <h1>Want to learn more?</h1>
      <h3>See how BentoBox can help your restaurant.</h3>
      <a target="_blank" href={"https://www.getbento.com/partnerships/MHM/"} rel="noreferrer" className={"ant-btn ant-btn-primary ant-btn-lg"}>Get a demo</a>
    </section>

  </div>
}
